import React from 'react'
import type { FieldSurface } from './fieldSurfaces/types'

const FieldSurfaceContext = React.createContext<FieldSurface | null>(null)

export function FieldSurfaceProvider({
  surface,
  children,
}: {
  surface: FieldSurface
  children: React.ReactNode
}) {
  return <FieldSurfaceContext.Provider value={surface}>{children}</FieldSurfaceContext.Provider>
}

export function useFieldSurface(): FieldSurface {
  return React.useContext(FieldSurfaceContext) ?? 'form'
}

/** Context thô — `null` nếu chưa có provider (khác default `'form'` của `useFieldSurface`). */
export function useFieldSurfaceContext(): FieldSurface | null {
  return React.useContext(FieldSurfaceContext)
}

/** Surface hiệu lực: prop ưu tiên, không có thì lấy từ provider. */
export function useResolveFieldSurface(surfaceProp: FieldSurface | undefined): FieldSurface {
  const fromContext = useFieldSurface()
  return surfaceProp ?? fromContext
}

/** @deprecated Dùng `useResolveFieldSurface` — giữ alias cho import cũ. */
export const resolveFieldSurface = useResolveFieldSurface
